(function(algolia) {
  'use strict';
  algolia.translations = {
    fr: {
      search: '<i class="fa fa-search"></i>',
      noCollectionFound: 'Aucune collection trouvée',
      allProducts: 'Voir tous les produits',
      matching: 'correspondant à',
      sortBy: 'Trié par',
      relevance: 'Pertinence',
      outOf: 'sur',
      resultsFound: 'résultats trouvés',
      oneResultFound: '1 résultat trouvé',
      noResultFound: 'Aucun résultat trouvé',
      addToCart: 'Ajouter au panier',
      searchForProduct: 'Rechercher un produit',
      selectedFilter: 'Filtres sélectionnés',
      clearAll: 'Tout effacer',
      noPageFound: 'Aucune page trouvée',
      outOfStock: 'En rupture de stock',
      durationHours: 'h',
      durationMinutes: 'min'
    },
    it: {
      search: '<i class="fa fa-search"></i>',
      noCollectionFound: 'Nessuna raccolta trovata',
      allProducts: 'Vedi tutti i prodotti',
      matching: 'corrisponde a',
      sortBy: 'Ordinato per',
      relevance: 'Rilevanza',
      outOf: 'su',
      resultsFound: 'risultati trovati',
      oneResultFound: '1 risultato trovato',
      noResultFound: 'Nessun risultato trovato',
      addToCart: 'Aggiungi al carrello',
      searchForProduct: 'Cerca un prodotto',
      selectedFilter: 'Filtri selezionati',
      clearAll: 'Cancellare tutto',
      noPageFound: 'Nessuna pagina trovata',
      outOfStock: 'Esaurito',
      durationHours: 'ora',
      durationMinutes: 'minuti'
    }
  };
   
  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Pas de résultat pour la recherche ' + render(text);
    },
    in: function() {
      return 'en ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Essayez de ' +
        render(html_tags[0]) +
        ' retirer les filtres ' +
        render(html_tags[1]) +
        ' ou de ' +
        render(html_tags[2]) +
        ' modifier votre recherche ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' sur'
      );
    },

    by: function(text, render) {
      return 'en ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[Shopify.locale][render(text)];
    },
  };
})(window.algoliaShopify);
